type TypeWithID = { id: string; id_?: string };

export function dedupeById<T extends TypeWithID>(array: Array<T>): Array<T> {
  if (!array || !array.length) return [];
  const seenIds = new Set();
  return array
    ?.filter(item => item?.id || item?.id_)
    ?.filter(item => {
      if (!seenIds.has(item?.id || item?.id_)) {
        seenIds.add(item?.id || item?.id_);
        return true;
      }
      return false;
    });
}
